'use client';

import React, { memo, useMemo } from 'react';
import AppIcon from './AppIcon';
import AppImage from './AppImage';

interface AppLogoProps {
  src?: string; // Image source
  iconName?: string; // Icon name when no image
  size?: number; // Height for logo image or size for icon
  width?: number; // Optional custom width for wordmark logos
  className?: string; // Additional classes
  imageClassName?: string; // Additional image classes
  onClick?: () => void; // Click handler
  alt?: string;
}

const AppLogo = memo(function AppLogo({
  src = '/styleai/fhitz-wordmark.png',
  iconName = 'SparklesIcon',
  size = 44,
  width = 154,
  className = '',
  imageClassName = '',
  onClick,
  alt = 'FHITZ logo',
}: AppLogoProps) {
  const containerClassName = useMemo(() => {
    const classes = ['flex items-center'];
    if (onClick) classes.push('cursor-pointer hover:opacity-80 transition-opacity');
    if (className) classes.push(className);
    return classes.join(' ');
  }, [onClick, className]);

  const finalImageClassName = useMemo(() => {
    const classes = ['flex-shrink-0 object-contain'];
    if (imageClassName) classes.push(imageClassName);
    return classes.join(' ');
  }, [imageClassName]);

  return (
    <div className={containerClassName} onClick={onClick}>
      {src ? (
        <AppImage
          src={src}
          alt={alt}
          width={width}
          height={size}
          className={finalImageClassName}
          priority={true}
          unoptimized={src.endsWith('.svg')}
        />
      ) : (
        <AppIcon name={iconName} size={size} className="flex-shrink-0" />
      )}
    </div>
  );
});

export default AppLogo;